import { styled } from "@mui/material";
import { CloseIcon } from "src/foundations/icons";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const styledCloseIcon = styled(CloseIcon)(({ theme }: { theme: SenecFPPTheme }) => ({
    color: theme.palette.neutralGray110.main,
}));
